<template>
  <component :is="comp" v-bind="$attrs" :texts="texts" :is-busy="isBusy" :action.sync="actionModel" @expand="onExpand" @confirm="onConfirm" @abort="onAbort" />
</template>

<script>
import Proxy from '@/proxies/SubstoreStockProxy';
import { getLegacyErrorMessage } from '@/utils/i18n';

export default {
  name: 'StockProductButtonConfirmation',

  components: {
    VButtonChoice: () => import('./ButtonChoice'),
    VCancel: () => import('./Cancel'),
    VGeneric: () => import('./Generic'),
    VTerminate: () => import('./Terminate'),
  },

  inheritAttrs: false,

  props: {
    action: {
      type: Object,
      required: false,
      default: null,
    },

    texts: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isBusy: false,
      textMappings: {
        confirmation: {
          termination: this.texts.orderTerminationSucceeded,
          reservationTermination: this.texts.orderReservationDeletionSucceeded,
          reactivation: this.texts.orderReactivationSucceeded,
        },
      },
      serviceActions: {
        reactivation: 'reactivate',
        termination: 'terminate',
        reservationTermination: 'terminateReservation',
        orderDeletion: 'terminateReservation',
        optin: 'optin',
      },
    };
  },

  computed: {
    comp() {
      switch (this.actionName) {
        case 'resendDocument':
          return 'VButtonChoice';
        case 'cancel':
          return 'VCancel';
        case 'termination':
          return 'VTerminate';
        default:
          return 'VGeneric';
      }
    },

    actionModel: {
      get() {
        return this.action;
      },
      set(v) {
        this.$emit('update:action', v);
      },
    },

    actionName() {
      return this.action?.name;
    },
  },

  methods: {
    async onConfirm(params, additionalParams) {
      this.isBusy = true;
      const { name, subscriptionTemplateId, uniqueSubscriptionId } = params;

      this.$webtrekk.viewPageWithPayload(`bestandsuebersicht.${name.toLowerCase()}.confirm`, {
        page_type: 'basket',
        shop_product_sku: subscriptionTemplateId,
      });

      try {
        await this.$store.dispatch('contract/change', { uniqueSubscriptionId });

        const serviceAction = this.serviceActions[name] || name;

        await new Proxy().stockAction(subscriptionTemplateId, uniqueSubscriptionId, serviceAction, additionalParams);

        this.actionResult({ name, content: this.textMappings.confirmation[name], reload: true });
        this.actionModel = null;
      } catch (e) {
        this.actionModel = Object.assign({}, this.actionModel, {
          message: {
            type: 'ERROR',
            supplier: () => getLegacyErrorMessage(e),
          },
        });
      } finally {
        this.isBusy = false;
      }
    },

    onExpand() {
      this.$webtrekk.viewPageWithPayload(`bestandsuebersicht.${this.actionName?.toLowerCase()}`, {
        page_type: 'basket',
        shop_product_sku: this.action?.subscriptionTemplateId,
      });
    },

    onAbort() {
      this.$webtrekk.viewPageWithPayload(`bestandsuebersicht.${this.actionName?.toLowerCase()}.abort`, {
        page_type: 'basket',
        shop_product_sku: this.action?.subscriptionTemplateId,
      });
    },
  },

  inject: ['actionResult'],
};
</script>
